// extracted by mini-css-extract-plugin
export default {"wrapdiv":"pricing_wrapdiv__zXINT","flexbox":"pricing_flexbox__SdLhk","flex":"pricing_flex__yuT2N","button":"pricing_button__xtHuY","price":"pricing_price__++uEt"};